import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import React, { useCallback, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import SaveCancelButtons from '../../../../../molecules/SaveCancelButtons'
import ImageInput from '../../../media/ImageInput'
import { useBrandImageUpload } from '../../../../../../api/media'
import SydModal from '../../../../../commonDesign/SydModal'
import { modalStyles } from '../brandModalStyles'

const AddImageForm = ({ open, onClose, onComplete }) => {
  const classes = modalStyles()
  const { mutateAsync: uploadImage, isLoading } = useBrandImageUpload()
  const [error, setError] = useState(null)
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      image: null
    }
  })
  const onSubmit = useCallback(async (formData) => {
    setError(null)
    const command = {
      fileName: formData.image.name,
      displayName: formData.image.displayName,
      file: formData.image.file,
      tags: { purpose: 'branding' }
    }
    try {
      const result = await uploadImage(command)
      if (result && result.success !== false) {
        form.reset()
        onComplete(result)
      }
    } catch (err) {
      console.error('Error saving branding image:', err)
      setError(err?.response?.data?.message || err?.message || 'An error occurred while saving')
    }
  }, [onComplete, form, uploadImage])

  return (
    <SydModal open={open} onClose={onClose} title='Upload branding image'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            name='image'
            control={form.control}
            render={({ field, fieldState }) => (
              <ImageInput {...field} error={fieldState.error} />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          {error && <div className={classes.errorMessage}>{error}</div>}

          <div className={classes.buttonRow}>
            <SaveCancelButtons
              containerClassName={classes.saveCancel}
              onSave={form.handleSubmit(onSubmit)}
              onCancel={onClose}
              isSubmitting={isLoading}
            />
          </div>
        </Grid>
        <Grid item xs={12}>
          <p><em>*Uploaded images will be publicly accessible.</em></p>
        </Grid>
      </Grid>
    </SydModal>
  )
}

AddImageForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onComplete: PropTypes.func
}

export default AddImageForm
